
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["lucide lucide-hard-drive-upload",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 6l-4-4-4 4M12 2v8"}}),_c('rect',{attrs:{"width":"20","height":"8","x":"2","y":"14","rx":"2"}}),_c('path',{attrs:{"d":"M6 18h.01M10 18h.01"}})])
          )
        }
      }
    